module.exports = __webpack_public_path__ + "static/media/TP20.47bc89af.jpg";